var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpiTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.91,24.586l-10-22c-0.174-0.385-0.573-0.618-0.991-0.583c-0.42,0.034-0.774,0.329-0.884,0.736l-2.627,9.717 l-4.477-9.869c-0.174-0.384-0.562-0.615-0.99-0.584c-0.42,0.034-0.774,0.327-0.885,0.733l-12.02,44 c-0.119,0.438,0.07,0.901,0.463,1.128C8.654,47.956,8.828,48,9,48c0.259,0,0.515-0.1,0.708-0.293l9.828-9.828l-2.395,8.86 c-0.118,0.438,0.073,0.9,0.465,1.127c0.156,0.09,0.329,0.134,0.5,0.134c0.26,0,0.517-0.101,0.709-0.294l21.895-22 C41.002,25.411,41.083,24.965,40.91,24.586z M21.254,5.937l8.549,18.846L10.958,43.628L21.254,5.937z M20.053,43.625l2.321-8.585 l9.333-9.333c0.294-0.294,0.376-0.741,0.204-1.12l-4.236-9.339l0.047,0.013l2.519-9.316l8.564,18.84L20.053,43.625z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiTransfer);
export default __webpack_public_path__ + "static/media/upi-transfer.8de727641e0809b9f8e4469cf5448100.svg";
export { ForwardRef as ReactComponent };